<div class="panel panel--components">
  <!-- Header -->
  <div class="sysheader">
    <div class="panel__header__title">
      {{'Equaliser Bar' | translate | async}}
    </div>
    <div class="photo-container" *ngIf="InspectionId != null">
      <div class="photo-container" *ngIf="loadData">
        <ng-container *ngFor="let photo of equaliserBar.EqBarImages">
          <div>
            <img
              class="inspection-observation-photo"
              [src]="sanitize(photo)"
              (click)="viewComponentPhoto(photo)"
            />
          </div>
        </ng-container>

        <app-add-new-photo
          (SystemPhotoUpload)="loadSystemImages($event)"
          [inspectionId]="InspectionId"
          [inspectionDetailId]="InspDetailId"
          [systemId]="SystemId"
          [comingFrom]="comingFrom"
        ></app-add-new-photo>

        <div
          style="cursor: pointer"
          [title]="(imageHistoryAvailable ? 'Images History' : 'No Images History') | translate | async"
          *ngIf="InspectionId > 0"
        >
          <i
            class="material-icons upload-container__icon"
            [ngClass]="{'icon-active' : imageHistoryAvailable,'icon-inactive': !imageHistoryAvailable}"
            [class.disabled-icon]="!imageHistoryAvailable"
            [style.pointer-events]="imageHistoryAvailable ? 'auto' : 'none'"
            (click)="imageHistoryAvailable && openPhoto()"
          >
            photo_library
          </i>
        </div>
      </div>
      <div *ngIf="loadData">
        <app-comment-component
          [inspectionId]="InspectionId"
          (commentUpdated)="onCommentUpdated($event)"
          [comment]="equaliserBar.EqBarComment"
          [equipmentId]="EquipmentId"
          [endPoint]="comingFrom"
          [ScreenId]="7"
        >
        </app-comment-component>
      </div>
    </div>
  </div>

  <!-- Main Row -->
  <div class="panel__sub-header">
    <div class="column-container flex-grow">
      <!-- Image -->
      <div class="column-container__column">
        <div class="text-block">
          <img
            *ngIf="!FamilyImage_Equaliser"
            src="/Content/Images/EqualiserBarFront.png"
            class="equaliser-image"
          />

          <img
            *ngIf="FamilyImage_Equaliser"
            [src]="getImage(FamilyImage_Equaliser)"
            class="equaliser-image"
          />
        </div>
      </div>

      <!-- Type -->
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{'Type' | translate | async}}
          </span>

          <!-- Inspection Screen -->
          <mat-radio-group
            *ngIf="IsInspection; else viewMode"
            [(ngModel)]="equaliserBar.ToeOut"
            (change)="onEqualiserBarChanged('ToeOut')"
            class="equaliser-type-radio"
          >
            <mat-radio-button [value]="1">
              {{'Toe Out' | translate | async}}
            </mat-radio-button>

            <mat-radio-button [value]="2">
              {{'Straight' | translate | async}}
            </mat-radio-button>
          </mat-radio-group>

          <!-- View Mode -->
          <ng-template #viewMode>
            <span class="text-block__important">
              {{ equaliserBar?.ToeOut === 1 ? ('Toe Out' | translate | async) :
              equaliserBar?.ToeOut === 2 ? ('Straight' | translate | async) : ''
              }}
              <!-- <mat-icon  class="edit-icon" (click)="openEqualiserBarDialog()">
              edit
            </mat-icon> -->
              <i
                *ngIf="IsEdit"
                class="material-icons text-container__edit cursor-font"
                title="Click to edit Component"
                (click)="openEditComponentPopup()"
                >edit</i
              >
            </span>
          </ng-template>
        </div>
      </div>

      <!-- Condition -->
      <div class="column-container__column" *ngIf="IsCondition">
        <div class="text-block">
          <span class="text-block__label">
            {{'Condition' | translate | async}}
          </span>

          <div class="condition-container">
            <select
              class="frameconditionoptions"
              [(ngModel)]="equaliserBar.Condition"
              (change)="onEqualiserBarChanged('Condition')"
              [ngClass]="{
              'frameconditionoptionscolorA': equaliserBar.Condition === 'A',
              'frameconditionoptionscolorB': equaliserBar.Condition === 'B',
              'frameconditionoptionscolorC': equaliserBar.Condition === 'C',
              'frameconditionoptionscolorX': equaliserBar.Condition === 'X'
              }"
            >
              <option value="A" class="frameconditionoptionscolorA">A</option>

              <option value="B" class="frameconditionoptionscolorB">B</option>

              <option value="C" class="frameconditionoptionscolorC">C</option>

              <option value="X" class="frameconditionoptionscolorX">X</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column-container__column gap-flex" *ngIf="!IsCondition">
        <div class="text-block">
          <span class="text-block__label">
            {{'Center' | translate | async}} ({{MeasurementUnit}})
          </span>
          <div *ngIf="InspectionId != null">
            <input class="input-readings" type="number"
            [(ngModel)]="equaliserBar.MeasurementCenter"
            (change)="updateComponentMeasurement('MC', equaliserBar.MeasurementCenter)" 
            [ngClass]="borderClassCenter" />
          </div>
          <div *ngIf="InspectionId == null">
            <span class="measurement-value">
              {{ equaliserBar.MeasurementCenter ?? '-' }}
            </span>
          </div>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{'Outer Left' | translate | async}} ({{MeasurementUnit}})
          </span>
          <div *ngIf="InspectionId != null">
            <input class="input-readings"  type="number"
            [(ngModel)]="equaliserBar.MeasurementOuterLeft"
            (change)="updateComponentMeasurement('MOL', equaliserBar.MeasurementOuterLeft)"
            [ngClass]="borderClassOLeft"/>
          </div>
          <div>
            <span class="measurement-value" *ngIf="InspectionId == null">
              {{ equaliserBar.MeasurementOuterLeft ?? '-' }}
            </span>
          </div>
        </div>
        <div class="text-block">
          <span class="text-block__label">
            {{'Outer Right' | translate | async}} ({{MeasurementUnit}})
          </span>
          <div *ngIf="InspectionId != null">
            <input class="input-readings"  type="number" 
            [(ngModel)]="equaliserBar.MeasurementOuterRight"
            (change)="updateComponentMeasurement('MOR', equaliserBar.MeasurementOuterRight)"
            [ngClass]="borderClassORight"/>
          </div>
          <div>
            <span class="measurement-value" *ngIf="InspectionId == null">
              {{ equaliserBar.MeasurementOuterRight ?? '-' }}
            </span>
          </div>
        </div>
      </div>
      <!-- Date Installed -->
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{'Date Installed' | translate | async}}
          </span>

          <span class="text-block__important">
            {{equaliserBar?.DisplayDateInstalled | date:'dd-MMM-yyyy'}}
          </span>
        </div>
      </div>

      <!-- SMU -->
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{'Equipment SMU/Hourmeter at Install' | translate | async}}
          </span>

          <span class="text-block__important"> {{equaliserBar?.CMU}} hrs </span>
        </div>
      </div>

      <!-- Life -->
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{'Life Lived' | translate | async}}
          </span>

          <span class="text-block__important">
            {{ (equaliserBar?.LifeLived ?? 0) }} hrs
          </span>
        </div>
      </div>

      <!-- Budget -->
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{'Budget Life' | translate | async}}
          </span>

          <span class="text-block__important">
            {{equaliserBar?.BudgetLife}} hrs
          </span>
        </div>
      </div>

      <!-- Brand -->
      <div class="column-container__column">
        <div class="text-block">
          <span class="text-block__label">
            {{'Brand' | translate | async}}
          </span>

          <span class="text-block__important"> {{equaliserBar?.Make}} </span>
        </div>
      </div>
    </div>
  </div>
</div>
